import {z} from 'zod';
import {baseCardSchema} from './baseSchemas';
import {ScheduleType} from 'common/src/modules/decisionTree/decisionTree.types';
import {TimezoneSource} from 'common/src/modules/timezones/timezones.types';
import {NodeType} from 'common/src/modules/nodes/nodes.types';

// Date range schema for schedule outputs
const dateRangeSchema = z.object({
  start: z
    .string()
    .describe(
      'Start date/time in ISO format. If the user did not specify time of day, use the time of day 00:00:00.',
    ),
  end: z
    .string()
    .describe(
      'End date/time in ISO format. If the user did not specify time of day, use the time of day 23:59:59.',
    ),
});

const daysOfWeekSchema = z.object({
  days: z.array(z.number()).describe('Days of the week (0-6, Sunday-Saturday)'),
  startHour: z.number().min(0).max(23).describe('Start hour of the day (0-23)'),
  endHour: z.number().min(0).max(23).describe('End hour of the day (0-23)'),
});

// Schedule output schema
export const scheduleOutputSchema = z.object({
  name: z.string().describe('The name of the output'),
  daysOfWeek: z
    .array(daysOfWeekSchema)
    .nullable()
    .describe('Configuration per day of the week and time of day'),
  dateRange: dateRangeSchema.nullable().describe('Configuration per date range'),
});

// Schedule Card Schema
export const scheduleCardSchema = baseCardSchema.extend({
  type: z.literal(NodeType.SCHEDULE),
  scheduleType: z
    .nativeEnum(ScheduleType)
    .describe('The type of schedule (Date range or Days of week)'),
  timezoneSource: z
    .nativeEnum(TimezoneSource)
    .describe('The timezone source identifier (manual, user, advertiser)'),
  timeZone: z.string().describe('The timezone string, e.g. America/New_York'),
  randomizeOutputs: z.boolean().describe('Whether to randomize outputs'),
  outputs: z
    .array(scheduleOutputSchema)
    .describe('The outputs of the schedule card, NEVER ADD FALLBACK OUTPUT'),
});
